import { useAppContext } from '../../contexts/AppContext/AppContext';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import React, { ComponentProps } from 'react';
import {
  CollapsibleContainerBlockInteractions,
  CollapsibleContainerBlockProps,
} from './partials/CollapsibleContainerBlockInteractions';
import { CollapsibleContainerBlockDefault } from './views/CollapsibleContainerBlockDefaultView';

function CollapsibleContainer({ views, activeView }: CollapsibleContainerBlockProps) {
  const { editModeInfo } = useAppContext();

  if (editModeInfo.active) {
    return (
      <CollapsibleContainerBlockInteractions views={views} activeView={activeView} />
    );
  }
  return <CollapsibleContainerBlockDefault views={views} />;
}

export const CollapsibleContainerBlock = asFetchableBlock(CollapsibleContainer, BlockType.collapsiblecontainer);
export type CollapsibleContainerBlock = ComponentProps<typeof CollapsibleContainerBlock>;
